import React, { useState, useEffect, useCallback } from "react";

import { SubHeading, MenuItem } from "../../components";
import { data } from "../../constants";
import useInView from "../../hooks/useInView";
import "./SpecialMenu.css";

const CATEGORIES = [
  { key: "pho", label: "Pho" },
  { key: "appetizer", label: "Appetizer" },
  { key: "vermicelli", label: "Vermicelli or Rice" },
  { key: "lomein", label: "Lo Mein" },
  { key: "rice_and_noodle", label: "Fried Rice & Noodle" },
  { key: "kids", label: "Kids Meal" },
  { key: "beverages", label: "Beverages" },
  { key: "boba", label: "Boba Tea" },
];

const CATEGORY_SUBTITLES = {
  kids: "Served Under Age 12",
  boba: "All $7.50 | $8 for mix of 2 flavors",
};

const SpecialMenu = () => {
  const [activeTab, setActiveTab] = useState("pho");
  const [fadeKey, setFadeKey] = useState(0);
  const [titleRef, titleVisible] = useInView();

  const switchTab = useCallback((key) => {
    setActiveTab(key);
    setFadeKey((prev) => prev + 1);
  }, []);

  // Listen for tab switch events from navbar
  useEffect(() => {
    const handleSwitchTab = (e) => {
      const { category } = e.detail;
      if (data[category]) {
        switchTab(category);
      }
    };
    window.addEventListener("switchMenuTab", handleSwitchTab);
    return () => window.removeEventListener("switchMenuTab", handleSwitchTab);
  }, [switchTab]);

  const activeItems = data[activeTab] || [];
  const subtitle = CATEGORY_SUBTITLES[activeTab];

  return (
    <div className="app__specialMenu flex__center section__padding" id="menu">
      <div
        ref={titleRef}
        className={`app__specialMenu-title fade-in-section ${titleVisible ? "visible" : ""}`}
      >
        <h1 className="headtext__cormorant">Our Menu</h1>
        <SubHeading title="*additional $1 charge for takeout" />
      </div>

      {/* Tab Bar */}
      <div className="app__specialMenu-tabs">
        {CATEGORIES.map((cat) => (
          <button
            key={cat.key}
            className={`app__specialMenu-tab ${
              activeTab === cat.key ? "app__specialMenu-tab--active" : ""
            }`}
            onClick={() => switchTab(cat.key)}
          >
            {cat.label}
          </button>
        ))}
      </div>

      {/* Active Category Content */}
      <div className="app__specialMenu-content" key={fadeKey}>
        <p className="app__specialMenu-menu_heading">
          {CATEGORIES.find((c) => c.key === activeTab)?.label}
        </p>
        {subtitle && (
          <p className="app__specialMenu-menu_subheading">{subtitle}</p>
        )}
        <div className="app__specialMenu_menu_items">
          {activeItems.map((item, index) => (
            <MenuItem
              key={item.title + index}
              title={item.title}
              price={item.price}
              tags={item.tags}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SpecialMenu;
